import * as React from 'react';
import { SVGProps } from 'react';

const SvgFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.333 4C7.75 4 4 7.742 4 12.35a8.35 8.35 0 0 0 7.033 8.25v-5.833H8.916V12.35h2.117v-1.842c0-2.092 1.242-3.242 3.15-3.242.908 0 1.858.158 1.858.158v2.058h-1.05c-1.033 0-1.358.642-1.358 1.3v1.567h2.317l-.375 2.417h-1.942v5.833a8.333 8.333 0 0 0 7.034-8.25c0-4.608-3.75-8.35-8.333-8.35z" />
  </svg>
);

export default SvgFacebook;
